import React from "react";
import styled from "styled-components";
import causeImage from "../images/duckInHand.jpg";

const Section = styled.section`
  background: #fffcf2;
  padding: 5rem 1.5rem;
`;

const Wrap = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const Media = styled.div`
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 30px 60px -20px rgba(10, 42, 74, 0.25);
  aspect-ratio: 4 / 3;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      transparent 50%,
      rgba(10, 42, 74, 0.55) 100%
    );
  }
`;

const Badge = styled.span`
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 2;
  background: #ffce2d;
  color: #0a2a4a;
  font-weight: 800;
  font-size: 0.8rem;
  letter-spacing: 0.1em;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  text-transform: uppercase;
`;

const Eyebrow = styled.p`
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 0.85rem;
  color: #faa71e;
  font-weight: 700;
  margin-bottom: 0.5rem;
`;

const Heading = styled.h2`
  font-size: clamp(1.8rem, 4vw, 2.6rem);
  color: #0a2a4a;
  font-weight: 800;
  line-height: 1.15;
  margin-bottom: 1.25rem;
`;

const Lead = styled.p`
  font-size: 1.1rem;
  color: #0a2a4a;
  font-weight: 600;
  margin-bottom: 1rem;
`;

const Body = styled.p`
  color: #2d3e56;
  line-height: 1.65;
  margin-bottom: 1rem;
`;

const Quote = styled.blockquote`
  border-left: 4px solid #ffce2d;
  padding-left: 1rem;
  margin: 1.5rem 0;
  color: #0a2a4a;
  font-style: italic;
  font-weight: 600;
`;

const CTA = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(250, 167, 30, 0.18);
  color: #b9740a;
  padding: 1rem 1.75rem;
  border: 1px dashed rgba(250, 167, 30, 0.7);
  border-radius: 999px;
  font-weight: 700;
  font-size: 1rem;
  cursor: default;
  user-select: none;
  font-family: inherit;
  margin-top: 1rem;
`;

const Cauza = () => {
  return (
    <Section id="cauza">
      <Wrap>
        <Media data-aos="fade-right" data-aos-duration="800">
          <Badge>Cauza 2026</Badge>
          <img src={causeImage} alt="Sprijin pentru nou-născuți" />
        </Media>
        <div data-aos="fade-left" data-aos-duration="800">
          <Eyebrow>Pentru ce luptăm</Eyebrow>
          <Heading>
            Dotarea Secției de Neonatologie a Spitalului „Louis Țurcanu”
          </Heading>
          <Lead>
            Fiecare rățușcă adoptată reprezintă o șansă în plus la viață pentru
            un nou-născut.
          </Lead>
          <Body>
            În 2026, fondurile strânse prin Cursa de Rățuște merg către dotarea
            Secției de Neonatologie a Spitalului Clinic de Urgență pentru Copii
            „Louis Țurcanu” din Timișoara — pătuțuri și aparate de monitorizare
            pentru nou-născuți.
          </Body>
          <Body>
            Secția îngrijește anual sute de bebeluși, inclusiv prematuri și
            copii care necesită îngrijire specializată din primele ore de
            viață. Pentru acești pacienți fragili, accesul la echipamente
            moderne este esențial pentru monitorizare, tratament și recuperare.
          </Body>
          <Quote>
            Împreună putem contribui la un start mai sigur în viață pentru cei
            mai mici pacienți ai Timișoarei.
          </Quote>
          <CTA aria-disabled="true">🔒 Ne vedem la anul!</CTA>
        </div>
      </Wrap>
    </Section>
  );
};

export default Cauza;
